import React from 'react';
import { Lock } from 'lucide-react';
import { cn } from '../../utils/cn';
function FormInput({
  label,
  error,
  multiline = false,
  className,
  id,
  ...props
}: {
  label: string;
  error?: string;
  multiline?: boolean;
  className?: string;
  id?: string;
} & React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>) {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');
  const base = ['w-full bg-brand-gray-900 text-brand-white px-4 py-3', 'border rounded-sm transition-colors duration-200', 'placeholder:text-brand-gray-500', 'focus:outline-none focus:border-brand-teal focus:ring-1 focus:ring-brand-teal', error ? 'border-red-500/60 focus:border-red-500 focus:ring-red-500' : 'border-brand-gray-700'].join(' ');
  return <div className="w-full flex flex-col gap-2" data-id="element-735">
      <label htmlFor={inputId} className="text-xs font-bold text-brand-gray-300 uppercase tracking-widest" data-id="element-736">
        {label}
      </label>
      {multiline ? <textarea id={inputId} className={cn(base, 'min-h-[120px] resize-y', className)} aria-invalid={!!error} aria-describedby={error ? `${inputId}-error` : undefined} {...props as React.TextareaHTMLAttributes<HTMLTextAreaElement>} data-id="element-737" /> : <input id={inputId} className={cn(base, className)} aria-invalid={!!error} aria-describedby={error ? `${inputId}-error` : undefined} {...props as React.InputHTMLAttributes<HTMLInputElement>} data-id="element-738" />}
      {error && <span id={`${inputId}-error`} role="alert" className="text-xs text-red-400 mt-0.5" data-id="element-739">
          {error}
        </span>}
    </div>;
}
function CaptchaContainer() {
  return <div className="flex items-center gap-3 p-4 border border-brand-gray-700 bg-brand-gray-900 rounded-sm" data-id="element-740">
      <div className="w-6 h-6 border-2 border-brand-gray-600 rounded-sm flex-shrink-0" data-id="element-741" />
      <span className="text-sm text-brand-gray-400 flex-grow" data-id="element-742">
        I'm not a robot
      </span>
      <div className="flex flex-col items-center gap-0.5" data-id="element-743">
        <Lock className="w-6 h-6 text-brand-gray-600" data-id="element-744" />
        <span className="text-[9px] text-brand-gray-600 leading-none" data-id="element-745">
          reCAPTCHA
        </span>
        <span className="text-[8px] text-brand-gray-700 leading-none" data-id="element-746">
          Privacy · Terms
        </span>
      </div>
    </div>;
}
const btnBase = 'inline-flex items-center justify-center font-semibold uppercase tracking-wider transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black active:scale-[0.97] active:transition-none clip-edges px-6 py-3 text-sm gap-2';
export function SubscribeForm() {
  return <div className="p-12 lg:p-24 flex flex-col justify-center border-b lg:border-b-0 lg:border-r border-white/5" data-id="element-747">
      <div className="max-w-md mx-auto w-full" data-id="element-748">
        <h2 className="text-3xl font-bold uppercase tracking-wider mb-4 text-brand-white" data-id="element-749">
          Stay Prepared
        </h2>
        <p className="text-base text-brand-gray-300 mb-8" data-id="element-750">
          Subscribe to stay up to date on the latest tactical course and
          education offerings.
        </p>
        <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-751">
          <FormInput label="Email Address" type="email" placeholder="Enter your email" required data-id="element-752" />
          <CaptchaContainer data-id="element-753" />
          <button type="submit" className={`${btnBase} bg-brand-teal text-brand-white border border-transparent hover:bg-brand-teal-light w-full`} data-id="element-754">
            Subscribe
          </button>
        </form>
      </div>
    </div>;
}